import { useTranslations } from "contexts/LocalizationContext";
import MenuLink from "modules/common/components/MenuLink";
import type { ResolvedMenuPagePaths } from "utils/menuUtils";

import {
  ChakraAccordionItem as AccordionItem,
  ChakraAccordionButton as AccordionButton,
  ChakraAccordionIcon as AccordionIcon,
  ChakraAccordionPanel as AccordionPanel,
  ChakraBox as Box,
  ChakraFlex as Flex,
} from "@airhelp/react-ui-components";

const MenuAccordionItem = ({ label, menu }: { label?: string; menu: ResolvedMenuPagePaths[] }) => {
  const translations = useTranslations();

  return (
    <AccordionItem>
      <AccordionButton px={8} py={5} bg="greyscale.300" _expanded={{ bg: "white" }}>
        <Box flex="1" textAlign="left" textTransform="uppercase" fontSize="xs" data-testid="footer-category">
          {translations(label)}
        </Box>
        <AccordionIcon boxSize={6} color="primary.500" />
      </AccordionButton>
      <AccordionPanel px={8} pb={3} pt={0} bg="white">
        <Flex direction="column">
          {menu &&
            menu.map((item) => {
              const { label: menuItemLabel } = item;

              return (
                <MenuLink
                  key={menuItemLabel}
                  menuItem={item}
                  variant="footerLight"
                  fontSize="sm"
                  linkType=""
                  mb={5}
                  data-testid="footer-elements"
                />
              );
            })}
        </Flex>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default MenuAccordionItem;
